import { Modal, ModalBody, ModalContent, ModalOverlay, Tooltip } from '@chakra-ui/react';
import { LockedIcon, UpdateIcon } from '@sketchnote/icons';
import { useRouter } from 'next/router';
import React from 'react';
import { API } from 'src/api';
import useCollaborativeEditorStore from 'src/features/collaborative-editor/components/liveblocks/collaborativeEditorStore';
import { VersionHistory } from 'src/features/collaborative-editor/components/VersionHistory';
import { useFileStore } from 'src/features/files';

export const VersionHistoryButton = ({ disabled }: { disabled: boolean }) => {
  const isVersionHistoryOpen = useFileStore((s) => s.isVersionHistoryOpen);
  const router = useRouter();
  const docId = router.query.view as string;
  const { onDeselectEditor } = useCollaborativeEditorStore();
  const handleVersionHistoryModal = (open: boolean) => {
    if (onDeselectEditor) {
      onDeselectEditor();
    }
    useFileStore.setState({ isVersionHistoryOpen: open });
  };
  return (
    <>
      <button
        onClick={() => handleVersionHistoryModal(true)}
        disabled={disabled}
        className="pl-8 flex py-20 text-gray-600 text-sm items-center border-t w-full border-gray-200 hover:text-gray-800 cursor-pointer"
      >
        <UpdateIcon wrapperClass="mt-3 inline-block mr-4 text-gray-500 text-base" />{' '}
        <span>Version history</span>
        {disabled && (
          <Tooltip label="This feature is locked in your current plan. Upgrade to unlock.">
            <LockedIcon className="ml-8" />
          </Tooltip>
        )}
      </button>

      <Modal isOpen={isVersionHistoryOpen} onClose={() => handleVersionHistoryModal(false)}>
        <ModalOverlay />
        <ModalContent
          width="auto"
          maxWidth="auto"
          maxHeight="auto"
          margin="auto"
          borderRadius="0.8rem"
          className="static rounded-lg"
        >
          <ModalBody className="flex items-center justify-center text-left" padding="0px">
            <VersionHistory
              docId={docId}
              onClose={() => {
                handleVersionHistoryModal(false);
              }}
              onApply={() => {
                handleVersionHistoryModal(false);
              }}
            />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
